import { useEffect, ReactNode } from 'react'
import { useAuth } from '../context/auth-context'
import { AuthenticatedApp } from './AuthenticatedApp'
import { UnauthenticatedApp } from './UnauthenticatedApp'
import { /*useHistory,*/ Redirect, useHistory } from 'react-router'
import { LoggedOutRoutes } from './routes'

/**
 * When a user refreshes or goes to a page via a link, at first the user context will not
 * be there yet. Therefore first the UnauthenticatedApp is rendered and it redirects to
 * the homepage (login). Once the user context is loaded, we should send the user back
 * to the link he intended to go to.
 */
const REDIRECT_AFTER_LOGIN_KEY = 'personaeRedirectAfterLoginHref'
const InterceptAuthApp = (): JSX.Element => {
  const { user, initialLoadDone } = useAuth()
  const history = useHistory()

  const onRedirect = (pathName: string): ReactNode => {
    // While me query is running wait before redirecting to login
    if (!initialLoadDone) {
      return null
    }
    // Note: We use localStorage since data needs to survive real Browser redirect to SAML SSO
    localStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, pathName)
    return <Redirect to={LoggedOutRoutes.home} />
  }

  useEffect(() => {
    // If the user is loaded and we have redirection, replace the current location with the
    // one the user actually wanted to go to, then remove the redirectPathName
    const redirectPathName = localStorage.getItem(REDIRECT_AFTER_LOGIN_KEY)
    if (redirectPathName && user) {
      history.replace(redirectPathName)
      localStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY)
    }
  }, [user, history])

  return <>{user ? <AuthenticatedApp /> : <UnauthenticatedApp onRedirect={onRedirect} />}</>
}

export { InterceptAuthApp }
